// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-bd032dc4]{width:100%}.container .content[data-v-bd032dc4]{height:calc(100vh - 160px);overflow-y:scroll;padding:30px}.container .content .row[data-v-bd032dc4]{margin-bottom:25px}.container .content .row[data-v-bd032dc4],.container .content .row .imgWrap[data-v-bd032dc4]{display:flex;align-items:center}.container .content .row img[data-v-bd032dc4]{width:300px;height:200px}", ""]);
// Exports
module.exports = exports;
